import React, { useEffect, useState } from "react";

const SlideShow = ({ images, title }) => {
	const [imageIndex, setImageIndex] = useState(0);

	useEffect(() => {
		setInterval(() => {
			const randomNumber = Math.floor(Math.random() * images.length);
			setImageIndex(randomNumber);
		}, 2000);
	}, []);

	return <img src={images[imageIndex]} alt={title} />;
};

export default SlideShow;
